import styled from 'styled-components';

export const FooterContainer = styled.footer`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 1rem;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  margin-top: 1.5rem;
  padding: 1rem 0 0.25rem;
  border-top: 1px solid var(--border-default);
  color: var(--text-secondary);
`;

export const CopyrightText = styled.p`
  margin: 0;
  text-align: center;
  font-size: 0.875rem;
  line-height: 1.4;
`;

export const Actions = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.75rem;
  width: 100%;

  @media (max-width: 700px) {
    flex-direction: column;
  }
`;

export const Button = styled.button`
  flex: 1 1 0;
  min-width: 0;
  width: 100%;
  padding: 0.75rem 1rem;
  border-radius: 8px;
  background-color: var(--accent);
  color: var(--text-on-accent);
  border: none;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.2;
  text-align: center;

  &:hover {
    background-color: var(--accent-hover);
  }

  &:focus-visible {
    outline: 2px solid var(--info);
    outline-offset: 2px;
  }
`;
